import {notification, TabsProps} from 'antd'
import { Button, Collapse, Tabs } from 'antd'
import React, {useState} from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  useOkulSepetDetayQuery,
  useSepetSatiriSilMutation
} from '../../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../../spinner/Spinner'
const { Panel } = Collapse

const OkulSepetleriDetailPage = () => {
  const { sepetId } = useParams()
  const navigate = useNavigate()
  const [sepetSatirifSilMutation] = useSepetSatiriSilMutation()
  const [submitting, setSubmitting] = useState(false)
  // API isteğini gerçekleştir
  const { data, loading, error , refetch} = useOkulSepetDetayQuery({
    variables: { sepet_id: parseInt(sepetId!) },
    skip: !sepetId || isNaN(Number(sepetId)), // Geçersiz ID varsa isteği yapma
  })

  if (loading || submitting) {
    return <Spinner showSpinner={loading} color="red" />
  }

  if (error) {
    console.error('API Hatası:', error)
    navigate('/')
    return null
  }

  const handleDelete = async (id: number) => {
    setSubmitting(true)
    try {
      const response = await sepetSatirifSilMutation({
        variables: {
          id: id,
        },
      })

      if (response.data?.sepetSatiriSil.success) {
        notification.success({
          message: '',
          description: `${response.data?.sepetSatiriSil?.message}`,
          duration: 6,
        })
        await refetch()
      } else {
        notification.error({
          message: '',
          description: `${response.data?.sepetSatiriSil?.message}`,
          duration: 6,
        })
      }
    } catch (error) {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    }finally {
      setSubmitting(false)
    }
  }

  const sepetDetay = data?.okulSepetDetay?.sepet_bilgileri
  const sepetLines = data?.okulSepetDetay?.sepet_satirlari
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Sepet Bilgileri',
      children: (
        <div className="okul-yonetim-admin-detail-tab ">
          <div className="tab-container">
            <h1>Sepet Bilgileri</h1>
            <div className="tab-content">
              <div className="tab-content-row">
                <div className="tab-content-row-label">Banka onay tarihi</div>
                <div className="tab-content-row-value">{sepetDetay?.banka_3d_onay_tarihi ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Banka ödeme tarihi</div>
                <div className="tab-content-row-value">{sepetDetay?.banka_odeme_tarihi ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Değişim</div>
                <div className="tab-content-row-value">{sepetDetay?.degisim ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Kullanıcı</div>
                <div className="tab-content-row-value">{sepetDetay?.kullanici ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Sınıf İsmi</div>
                <div className="tab-content-row-value">{sepetDetay?.sinif_ismi ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Tarih</div>
                <div className="tab-content-row-value">{sepetDetay?.tarih ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Vade Ücreti</div>
                <div className="tab-content-row-value">{sepetDetay?.vade_ucreti ?? '-'}</div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '2',
      label: 'Sepet Satırları',
      children: (
        <div className="okul-yonetim-admin-collapse-tap">
          {sepetLines?.map((line, index) => (
            <Collapse key={index} bordered={false}>
              <Panel
                header={
                  <div className="collapse-header-content">
                    <div style={{ maxWidth: 170 }} className="header-title">
                      <span className="header-left">#{line?.sepet_id} </span>
                      <span className="header-right">{line?.urun ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Öğrenci Adı </span>
                      <span className="header-right">{line?.ogrenci_ismi ?? '-'} </span>
                    </div>{' '}
                    <div className="header-title">
                      <span className="header-left">Adet </span>
                      <span className="header-right">{line?.adet ?? '-'} </span>
                    </div>{' '}
                    <div className="header-title">
                      <span className="header-left">Sınıf İsmi</span>
                      <span className="header-right">{line?.sinif_ismi ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Öğrenci T.C. No</span>
                      <span className="header-right">{line?.tc_kimlik_no ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <Button onClick={() => handleDelete(line?.id ?? 0)} type="primary">
                        Sil
                      </Button>
                    </div>
                  </div>
                }
                key="1"
              >
                <div className="admin-collapse-content-div">
                  <div className="okul-sepeti-admin-student-info">
                    <div className="header-title">
                      <span className="header-left">T.C. No </span>
                      <span className="header-right">{line?.urun ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Sınıf </span>
                      <span className="header-right"> {line?.sinif_id} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Cinsiyeti </span>
                      <span className="header-right">{line?.ogrenci_cinsiyet ?? '-'} </span>
                    </div>
                  </div>
                </div>
              </Panel>
            </Collapse>
          ))}
        </div>
      ),
    },
  ]
  return (
    <div className="okul-siparis-detay-page">
      <div className="okul-sepeti-admin-header">
        <h1>Okul Sepetleri</h1>
      </div>

      {/* Sipariş Detaylarını Göster */}
      <div className="siparis-detay">
        {data ? <Tabs defaultActiveKey="1" items={items} /> : <p>Sipariş bilgisi bulunamadı.</p>}
      </div>
    </div>
  )
}

export default OkulSepetleriDetailPage
